import React, { useEffect } from "react";
import AllProjects from "../../components/AllProjects/AllProjects";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import MainNav from "../../shared/MainNav/MainNav";

export default function Projects() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="projects" />
      <PageTop pageTitle="All Projects" />
      <AllProjects />
      <Footer />
    </>
  );
}
